import customAxios from "../../customAxios";
import {UPDATE_COMPANY_2_IS_FAVORITE, UPDATE_COMPANY_2_NOT_FAVORITE} from "../../routes";

const udpateCompany2IsFavorite = async (_id: string, isFavorite: boolean): Promise<any> => {
  let url: string = "";
  if (isFavorite)
    url = UPDATE_COMPANY_2_NOT_FAVORITE + '/' + _id
  else url = UPDATE_COMPANY_2_IS_FAVORITE + '/' + _id;
  try {
    return (await customAxios.patch(url )).data;
  } catch (error: unknown) {
    console.error({UPDATE_COMPANY_2_IS_FAVORITE: error});
    return false;
  }
};

export default udpateCompany2IsFavorite;
